import React, { useState } from "react";
import { Box, Button, Flex, Image, Text } from "@chakra-ui/react";
import TableCommissionConfirmation from "./tableCommissionConfirmation";
import iconExcel from "../../assets/images/employee/iconExcel.svg";
import { useCommissionConfirmation } from "../../hooks/useCommissionConfirmation";
import toast from "react-hot-toast";
import { commissionConfirmationCall } from "../../api/commissionConfirmation";
import { exportFile } from "../../utils/tools";

export default function CommissionConfirmation() {
  const [paramExport, setParamExport] = useState(null);

  const { isRefetching, entries, commissionConfirmationData } =
    useCommissionConfirmation();

  const handleExport = async () => {
    const checkInColumnMapping = {
      code: "Mã phiếu",
      confirmCommissionStatus: "Trạng thái",
      saleOpeningEvent: "Tên đợt mở bán",
      project: "Tên dự án",
      priceForCommission: "Số tiền",
      serviceFeeType: "Phân loại PDV",
      approver: "Người nhận",
      lockingParticipant: "Người liên quan",
      bookingTime: "Ngày tạo yêu cầu",
    };
    if (commissionConfirmationData?.length) {
      const data = await commissionConfirmationCall.export(
        entries,
        paramExport,
      );
      if (data) {
        exportFile(data, checkInColumnMapping, "bang_xac_nhan_hoa_hong.xlsx");
        toast.success("Download file thành công");
      } else {
        toast.error("Không có dữ liệu");
      }
    } else toast.error("Không có dữ liệu");
  };

  return (
    <Box
      w={{ base: "100%" }}
      backgroundColor="var(--color-backgroundmain)"
      p={{ base: "24px 16px 16px" }}
    >
      <Flex alignItems={"center"} justifyContent={"space-between"}>
        <Flex alignItems={"center"} gap={{ base: "74px" }}>
          <Text fontSize={{ base: "20px" }} fontWeight={600}>
            Xác nhận phí dịch vụ
          </Text>
        </Flex>
        <Flex alignItems={"center"} gap={"16px"}>
          <Button
            display={"flex"}
            alignItems={"center"}
            p={"10px 16px 10px 12px"}
            gap={"8px"}
            h={"44px"}
            backgroundImage="var(--linear-gradient-excel)"
            _hover={{
              filter: "brightness(90%)",
            }}
            onClick={handleExport}
          >
            <Image src={iconExcel} />
            <Text
              fontSize={{ base: "15px" }}
              fontWeight={600}
              color="var(--color-main)"
            >
              Xuất excel
            </Text>
          </Button>
        </Flex>
      </Flex>
      <Box mt={{ base: "23px" }}>
        <TableCommissionConfirmation
          isRefetchingWithCreate={isRefetching}
          paramData={setParamExport}
        />
      </Box>
    </Box>
  );
}
